// TODO(HB-5547): Position templates have no Priority Resource Pool field yet (wae-common only
// exposes `isPriorityResourcePool` on placements). The switch is UI-only until the backend ships
// it; confirm the field name, then flip IS_PRIORITY_RESOURCE_POOL_PERSISTED.
export const PRIORITY_RESOURCE_POOL_FIELD = 'isPriorityResourcePool';

export const IS_PRIORITY_RESOURCE_POOL_PERSISTED = false;
